import { Component } from '@angular/core';

@Component({
  selector: 'cs-standard-tab',
  standalone: true,
  imports: [],
  templateUrl: './cs-standard-tab.component.html',
  styleUrl: './cs-standard-tab.component.scss',
})
export class CsStandardTabComponent {}
